import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';

import Form from '../../../../components/Form/Form';
import Spinner from '../../../../components/Spinner';
import { authenticateUser } from '../../../../store/auth';

import './styles.scss';

class Component extends React.Component {
  state = {
    LinkedInAccess: "",
    Form: {
      Checkbox: false,
    },
    SubmittingApplication: false,
  }

  componentWillMount() {
    console.log("Url parameters:", this.props.location);
    if (this.props.location.query && this.props.location.query.error && this.props.location.query.error.indexOf("user_cancelled")>-1) {
      window.location = "/signup/advisor-apply";
    }
  }

  componentDidMount() {
    this.props.GetLinkedInMutation({
      variables: {
        AccessToken: this.props.location.query.code,
      },
    }).then(LinkedInAccess => this.setState({
      LinkedInAccess: LinkedInAccess.data.LinkedInSSO.access_token,
    })).catch(LinkedInAccess => this.setState({
      LinkedInAccess: false,
    }));
  }

  handleFormChange = event => this.setState({
    Form: {
      ...this.state.Form,
      ...event.target.value,
    },
  })

  handleCheckbox = event => this.setState({
    Form: {
      ...this.state.Form,
      Checkbox: this.state.Form.Checkbox === false,
    },
  })

  canSubmit = () => {
    if (this.state.Form.Checkbox === false) {
      return false;
    }

    if (Object.prototype.hasOwnProperty.call(this.state.Form, 'WhyBeAdvisor') === false) {
      return false;
    }

    if (this.state.Form.WhyBeAdvisor.trim() === '') {
      return false;
    }

    return true;
  }

  handleSubmission = () => {
    if (this.canSubmit()) {
      this.setState({
        SubmittingApplication: true,
      });

      this.props.AdvisorApplyMutation({
        variables: {
          AccessToken: this.state.LinkedInAccess,
          Questions: [
            {
              name: 'background_info',
              value: this.state.Form.BackgroundQuestion || null,
            },
            {
              name: 'why_be_advisor',
              value: this.state.Form.WhyBeAdvisor || null,
            },
          ]
        },
      }).then(UserSession => {
        window.setTimeout(() => window.location.href = '/advisor?signup=Linkedin', 200);
        this.props.authenticateUser(UserSession.data.advisorApply.token);
        this.setState({
          SubmittingApplication: false,
        });
      });
    }
  }

  render() {
    if (!this.state.LinkedInAccess) {
      return (
        <div style={{ padding: '40px 0' }} >
          <Spinner />
        </ div>
      );
    }

    if (this.state.LinkedInAccess === false) {
      return (
        <div style={{ padding: '40px 0' }} >
          <p>Error</p>
        </div>
      );
    }

    return (
      <div className="LinkedInSignup">
        <div className="container">
          <h2>Advisor Application</h2>
          <p>This will be used to evaluate your application and be shown to future prospective students.</p>
          <Form onChange={this.handleFormChange}>
            <p>Why do you want to be an advisor? (Max 150 words)</p>
            <textarea name="WhyBeAdvisor" rows="4" />
          </Form>
          <div className="CodeConduct__Wrapper">
            <div className="CodeConduct__Header">
              <h2>Code of Conduct</h2>
            </div>
            <div className="CodeConduct__Container">
              <p>
                Universities do not prepare students for finding jobs. Our mission at Paragon One is to bridge this gap and to help students pursue their dream careers. We rely on our advisors to provide insightful knowledge and feedback, and to ensure that our students receive the best possible experience for starting their careers. Towards that end, we have laid the following expectations:
              </p>
              <p>
                <b>Commitment</b>: We understand that your schedule is extremely busy. For that reason, Paragon One has no restrictions on how many sessions you choose to hold each month, or how many hours you put into the coaching program. However, we expect advisors to stay active (on a bi-monthly / quarterly basis) by partaking in coaching sessions, webinar talks, or other events.
                For more information on ways to get involved, click here.
              </p>
              <p>
                <b>Preparation</b>: Prior to each session, the Paragon One team will send information regarding the student you have been paired with, and the learning module for the session. We ask that you look over the material provided, and do any pre-session preparation work necessary.
              </p>
              <p>
                <b>Timeliness</b>: We ask that advisors be settled in and ready for the call about 10 minutes before the starttime.
              </p>
              <p>
                <b>Cancellation Policy</b>: We understand that unexpected events can pop up anytime. If you have to cancel your scheduled session with a student, we ask that you provide alternative times within 24-48 hours.
              </p>
              <p>
                <b>Paragon One Mission</b>: We have one goal - to give back to the student community by empowering young minds with the tools and knowledge needed to succeed. Our team depends on you advisors in delivering the support and encouragement for students to be able to pursue their careers, and we hope that you convey our mission through your sessions.
              </p>
              <p>
                <b>Community Conduct</b>: You are now part of the Paragon One Advisory Network, consisting of hundreds of professionals hailing from over 25 industries. We ask that you:
              </p>
              <ol>
                <li>Treat everyone with dignity and respect</li>
                <li>Be inclusive and considerate</li>
                <li>Be smart and careful with your words</li>
                <li>Be honest and forthcoming</li>
              </ol>
            </div>
            <div className="CodeConduct__Footer">
              <input onChange={this.handleCheckbox} type="checkbox" id="CodeConductCheckbox" />
              <label htmlFor="CodeConductCheckbox"><b>I agree to follow the code of conduct</b></label>
            </div>
            <button onClick={this.handleSubmission} {...(this.canSubmit()) ? {} : { disabled: true, }} >{
              (this.state.SubmittingApplication === false) ? 'Apply' : <Spinner className="spinner--white" />
            }</button>
          </div>
        </div>
      </div>
    );
  }
}

const GetLinkedInMutation = gql`
mutation (
  $AccessToken: String!
) {
  LinkedInSSO(code: $AccessToken) {
    access_token
  }
}`;

const AdvisorApplyMutation = gql`
mutation (
  $AccessToken: String!
  $Questions: [AdvisorApplicationQuestion]
) {
  advisorApply(AccessToken: $AccessToken, Questions: $Questions) {
    token
  }
}
`;

const mapStateToProps = (state) => ({
  authenticatedID: (typeof state.auth.sub !== 'undefined') ? state.auth.sub : null,
  authedUser: state.auth,
});

const mapDispatchToProps = {
  authenticateUser,
};

export default () => ({
  path: 'auth/linkedin',
  component: compose(
    graphql(GetLinkedInMutation, {
      name: 'GetLinkedInMutation'
    }),
    graphql(AdvisorApplyMutation, {
      name: 'AdvisorApplyMutation'
    })
  )(connect(mapStateToProps, mapDispatchToProps)(Component))
});



// WEBPACK FOOTER //
// ./src/routes/signup/routes/LinkedInSignup/index.js